const styles = theme => ({

  shareButtons: {
    marginTop: -5
  },
  shareButton: {
    margin: 10
  },
  shareHorizontal: {
    display: 'inline-block'
  },
  shareButtonNone: {
    outline: 'none'
  }

})

export default styles



// WEBPACK FOOTER //
// ./src/components/share/styles.js